import { OrderStatusEnum } from '../order-management/order-status.enum';
import { OrderLogUser } from '../order-management/order-log-user';

export interface ActionLog {
  logId: string;
  logDateTime: string;
  event: ActionLogEvent;
  logTypeCode: string;
  logTypeDesc: string;
  user: OrderLogUser;
  logItem: ActionLogItem;
}

export interface ActionLogEvent {
  eventCode: ActionLogEventCodes;
  eventNewStatus?: OrderStatusEnum;
}

export enum ActionLogEventCodes {
  CANCEL_REQUEST = 'CNL',
  MODIFY_REQUEST = 'MOD',
  LOCK_ENTITY = 'LOCK_ENTITY',
  CHANGE_STATUS_ORDER = 'CHANGE_STATUS_ORDER',
  CONFIRM_ORDER = 'CONFIRM_ORDER',
  CREATE_REQ = 'CREATE_REQ',
  CREATE_REQ_DRFT = 'CREATE_REQ_DRFT',
  MODIFY_ORDER = 'MODIFY_ORDER',
  MODIFY_PUMP = 'MODIFY_PUMP',
  ADD_PUMP = 'ADD_PUMP',
  REMOVE_PUMP = 'REMOVE_PUMP',
}

export interface ActionLogItem {
  logItemId: string;
  entitySource: string;
  changes: ActionLogChange[];
  product: {
    productCode: string;
    productDesc: string;
  };
}

export interface ActionLogChange {
  fieldName: string;
  fieldCode: string;
  oldValue?: string;
  newValue: string;
  items: ActionLogItem[];
  action: ActionLogActions;
}

export enum ActionLogActions {
  DELETE = -1,
  UPDATE = 0,
  CREATE = 1,
}
